import { historicalOriginalCustomer } from '../lib/legacyHistoricJobImport'

export function historicLinkCoverage(result, records) {
  const byId = new Map(records.map(record => [record.id, record]))
  const saved = (result?.result || []).filter(item => item.record_id)
  return saved.reduce((counts, item) => {
    const record = byId.get(item.record_id)
    counts[!record ? 'unavailable' : record.customer_id ? 'linked' : 'unlinked'] += 1
    return counts
  }, { linked: 0, unlinked: 0, unavailable: 0 })
}

export default function HistoricImportLinkReview({ result, records, owner, onReview, onRetry }) {
  const coverage = historicLinkCoverage(result, records)
  const byId = new Map(records.map(record => [record.id, record]))
  return <div className="legacy-historic-link-review" role="region" aria-label="Historical customer link review">
    <strong>Historical references saved. Customer links require separate owner review.</strong>
    <div className="field-hint">{result.result?.length || 0} source rows accounted for:
      {' '}{result.created} created, {result.reused} reused, {result.skipped} skipped.
      {' '}{coverage.linked} linked, {coverage.unlinked} unlinked
      {coverage.unavailable ? `, ${coverage.unavailable} not yet loaded` : ''}.</div>
    {coverage.unlinked > 0 && <div className="field-hint">
      Imported old jobs will not appear under a customer until their links are reviewed and confirmed.
      Name-only candidates are suggestions, never automatic links.
    </div>}
    {coverage.unavailable > 0 && <button type="button" className="btn btn-ghost btn-sm" onClick={onRetry}>
      Retry historical records</button>}
    <div className="legacy-historic-link-queue">{(result.result || []).filter(item => item.record_id).map(item => {
      const record = byId.get(item.record_id)
      return <div className="legacy-historic-link-row" key={item.row_number}>
        <span>Source row {item.row_number}: {record?.source_reference || 'Reference not yet loaded'}
          {record && ` / ${historicalOriginalCustomer(record.facts || {}) || 'Customer not supplied'}`}</span>
        <span>{!record ? 'Link status unavailable' : record.customer_id ? 'Linked' : 'Unlinked'}</span>
        {record && <button type="button" className="btn btn-ghost btn-sm" onClick={() => onReview(record.id)}>
          {owner && !record.customer_id ? 'Review customer link' : 'Open historical detail'}</button>}
      </div>
    })}</div>
  </div>
}
